import { ref, computed, onMounted } from 'vue';
import store from '@/store';
import { config } from '@/config.js';
import { useRoute } from '@/composables/common/router/useRouter';

export function useCategoriaResumen() {
    const route = useRoute();

    const resumen = ref({});
    const categoria = ref({});
    const loading = ref(false);

    const listaId = computed(() => route.params.lista_id);
    const categoriaId = computed(() => route.params.categoria_id);
    const configuracion = computed(() => store.getters.getConfig);

    // --- Download URLs ---

    const urlDescargaInforme = computed(() =>
        config.API_BASE + '/listas-abonados/' + listaId.value + '/bases/categorias/' + categoriaId.value + '/resumen/bases/informe?api_key=' + localStorage.getItem('token') + '&tid=' + (configuracion.value?.hash_teatro || '')
    );

    const urlDescargaListado = computed(() =>
        config.API_BASE + '/listas-abonados/' + listaId.value + '/bases/categorias/' + categoriaId.value + '/resumen/bases/informe/bases-pdf?api_key=' + localStorage.getItem('token') + '&tid=' + (configuracion.value?.hash_teatro || '')
    );

    // --- Data fetching ---

    async function fetch() {
        const params = {
            lista_id: listaId.value,
            categoria_id: categoriaId.value,
            filters: {}
        };

        loading.value = true;
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.categorias.resumen'),
                params
            );
            resumen.value = res.data.resumen || {};
            categoria.value = res.data.categoria || {};
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error('Error fetching categoria resumen:', error);
        } finally {
            loading.value = false;
        }
    }

    onMounted(() => {
        fetch();
    });

    return {
        resumen,
        categoria,
        loading,
        urlDescargaInforme,
        urlDescargaListado,
        fetch
    };
}
